import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import './OutputDisplay.css';

function OutputDisplay({
  outputImage,
  isGenerating,
  onGenerate,
  progress
}) {
  const handleDownload = () => {
    if (outputImage) {
      const link = document.createElement('a');
      link.href = outputImage;
      link.download = 'jewelry-tryon-result.png';
      link.click();
    }
  };

  return (
    <div className="upload-section output-section">
      <h2 className="section-title">Output</h2>

      <button
        className="generate-button"
        onClick={onGenerate}
        disabled={isGenerating}
      >
        {isGenerating ? (
          <>
            <span className="button-spinner"></span>
            <span>Generating...</span>
          </>
        ) : (
          <>
            <span className="button-icon">⚙️</span>
            <span>Generate Output</span>
          </>
        )}
      </button>

      <div className="preview-container output">
        {isGenerating ? (
          <div className="loading-container">
            <div className="loading-visual">
              <div className="shimmer-ring"></div>
              <div className="shimmer-ring delay-1"></div>
              <div className="shimmer-ring delay-2"></div>
              <span className="loading-icon">💎</span>
            </div>
            <p className="loading-text">Polishing your look...</p>
            <p className="loading-subtext">we are carefully placing your jewelry</p>
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${progress || 0}%` }}
              ></div>
            </div>
          </div>
        ) : outputImage ? (
          <div className="result-container">
            <TransformWrapper
              initialScale={1}
              minScale={0.5}
              maxScale={4}
              centerOnInit={true}
            >
              <TransformComponent>
                <img
                  src={outputImage}
                  alt="Try-on result"
                  className="preview-image zoomable"
                />
              </TransformComponent>
            </TransformWrapper>

            <div className="result-actions">
              <button className="action-button download" onClick={handleDownload}>
                <span>⬇️</span> Download
              </button>
              <p className="zoom-hint">🔍 Pinch or scroll to zoom</p>
            </div>
          </div>
        ) : (
          <div className="preview-placeholder">
            <div className="placeholder-icon">💍</div>
            <p className="placeholder-text">Your stunning result will appear here</p>
            <p className="placeholder-subtext">Upload images and click Generate</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default OutputDisplay;
